module.exports = __webpack_public_path__ + "static/media/kpi-icon.c96b4153.svg";